import Swal from 'sweetalert2';
import UsuarioService from './UsuarioService';
const usuarioService = new UsuarioService();

const Front : string = process.env.REACT_APP_FRONT || '';
export default class AlertService{
  
    alertaAdvertencia(titulo: string, mensaj: string) {
        Swal.fire({
          //position: 'top-end',
          icon: 'warning',
          title: titulo,
          text: mensaj,
          showConfirmButton: false,          
          //timer: 10000
        })
      }
      alertaExito(titulo: string, mensaj: string) {
        Swal.fire({
          //position: 'top-end',
          icon: 'success',
          title: titulo,
          text: mensaj,
          showConfirmButton: false,
          timer: 3000
        })
      }
      alertaAdvertenciaHtml(titulo: string, mensajeHtml: string) {
        Swal.fire({
          title: titulo,
          icon: 'warning',
          showConfirmButton: false,
          html: mensajeHtml
        });
      }
      alertaExitoHtml(titulo: string, mensajeHtml: string) {
        Swal.fire({
          title: titulo,
          icon: 'success',
          showConfirmButton: false,
          html: mensajeHtml,
          timer: 10000
        });
      }
      alertaAdvertenciaList(titulo: string, mensajeHtml: Array<string>) {
        const estructuraHtml = `
          <h2>Se presentaron las siguientes advertencias:</h2>
          <ul>
            ${mensajeHtml.map((error, index) => `<li key=${index}>${error}</li>`).join('')}
          </ul>
        `;
        Swal.fire({
          title: titulo,
          icon: 'warning',
          showConfirmButton: false,
          html: estructuraHtml
        });
      }  
      showLoading(titulo:string) {
        Swal.fire({
          title: titulo,
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton:false,
          showCancelButton: false,
          preConfirm: () => { },
          showLoaderOnConfirm: true,
          didOpen: () => {
            Swal.showLoading();
          }
        });
      }
      hideLoading(){
        Swal.close();
      }
      alertaProductoConferencia(titulo: string, mensaj: string,idproducto:number) {
        Swal.fire({
          title: titulo,
          text: mensaj,
          icon: 'question',
          showCancelButton: true,
          allowEscapeKey: false,
          allowOutsideClick: false,
          confirmButtonText: 'Si, ingresare conferencia!',
          cancelButtonText: 'No',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            //window.location.reload();
            window.location.href = Front+'Producto/conferencia/'+idproducto+'/0';
          }else{
            window.location.href = Front+'Producto/MisProductos';
          }
        })
      }


      alertaEliminarUsuario(titulo: string,mensaje: string, idUser: number, token: any){
        
        Swal.fire({
          title: titulo,
          text: mensaje,
          icon:'warning',
          showCancelButton: true,
          confirmButtonText:'Si, eliminar',
          cancelButtonText:'No'
        }).then(async (result)=>{
          if(result.isConfirmed){
            this.showLoading("Eliminando...");
            const respuesta = await usuarioService.ElminarUsuarioById(token,idUser);
            this.hideLoading();
            //console.log(respuesta)
            if(respuesta.strEstado == 'S') {
                this.alertaExito("Exito","El usuario ha sido eliminado");
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
                
            }else{
                this.alertaAdvertencia("Error",respuesta.strMensaje);
            }
          }
        })

      }
}